import { Button, Cell, Grid, Icon, Link, Text, VFlow } from 'bold-ui'
import { PageContent } from 'components/layout/PageContent'
import image from 'images/403-forbidden.png'
import React from 'react'
import { useHistory } from 'react-router'
import { Link as RouterLink } from 'react-router-dom'

export function ForbiddenView() {
  const history = useHistory()

  return (
    <PageContent>
      <Grid style={{ paddingTop: '10rem' }} alignItems='center' justifyContent='space-around'>
        <Cell>
          <VFlow>
            <VFlow vSpacing={0.5}>
              <h1>Você não tem acesso a essa página.</h1>
              <p>Peça permissão de acesso a esta funcionalidade ao administrador do sistema.</p>
            </VFlow>

            <p>
              <Button kind='primary' onClick={history.goBack}>
                <Icon icon='arrowLeft' style={{ marginRight: '0.25rem' }} />
                <Text color='inherit'>Retornar à página anterior</Text>
              </Button>
            </p>

            <p>
              <Link component={RouterLink} to='/'>
                Acessar página inicial
              </Link>
            </p>
          </VFlow>
        </Cell>
        <Cell>
          <img
            src={image}
            alt='Duas pessoas olhando para uma porta protegida por um lacre, representando que o acesso está proibido'
          />
        </Cell>
      </Grid>
    </PageContent>
  )
}
